const FALLBACK_FONTS = ['Arial', 'Helvetica', 'sans-serif']
const FALLBACK_FONTS_STRING = FALLBACK_FONTS.join(', ')

export const FONTS = {
  PRIMARY: 'var(--font-primary)',
  SECONDARY: 'var(--font-secondary)',
  FALLBACK: `DM Sans, ${FALLBACK_FONTS_STRING}`,
}

export const FONT_FAMILY = {
  PRIMARY: [FONTS.PRIMARY, FONTS.FALLBACK].join(', '),
  SECONDARY: [FONTS.SECONDARY, FONTS.FALLBACK].join(', '),
}
